import { ISubscriptionsState } from '@/@types'

const state: ISubscriptionsState = {
  recurlyToken: '',
  recurlyTokenActionId: '',
  recurlyTokenActionResult: '',
  paymentMethod: 'card',
  paymentEntries: {
    country: '',
    firstName: '',
    lastName: '',
    streetAddress: '',
    city: '',
    state: '',
    zip: '',
    phone: '',
    company: '',
    last4DigitsOfCreditCard: '',
    creditCardVendor: '',
  },
  couponInformation: {},
  checkoutPricing: {},
  checkoutDiscount: '0',
  checkoutTaxes: '0',
  checkoutSubtotal: '0',
  checkoutTotal: '0',
  isIn3dsFlow: false,
  isInPartnerFlow: false,
  promotionalField: '',
  paymentMethodOnFile: '',
  usersCurrentSubscriptions: [],
  userHasSubscription: false,
  userHasSkillDive: false,
  usersCurrentSubscriptionsWithPasses: [],
}

export default state
